import React, {useRef, useEffect, useState, useContext} from "react";
import { votingApi } from '../../helpers/fetcher';
import {
  RatingItemHeader,
  RatingItem,
  RatingSlider,
  RatingHeader,
  RatingSliderScale,
  SliderScaleMin,
  SliderScaleMax,
  Container,
} from "./styles";
import {DataContext} from '../../store/GlobalState'
import { ACTIONS } from '../../store/Actions';
const Slider = ({
  isSliding,
  axisName,
  leftValue,
  rightValue,
  sliderVal,
  onChangeValue,
  onClickSetMouseState,
  isTranslated,
  langForTransState
}) => {
  const isMobile = /Mobi/.test(window.navigator.userAgent)

  const mouseState = (state) => {
    onClickSetMouseState(state);
  };
  const { state: {groupRadarIdGlobalState: groupRadarIdGlobalStateStore, getTheWholeCardHtmlElms}, dispatch } = useContext(DataContext)
  const ratingTitleRef = useRef()
  const rating1Ref = useRef()
  const rating2Ref = useRef()

  const ratingTitleRef2 = useRef()
  const rating1Ref2 = useRef()
  const rating2Ref2 = useRef()

  const [translations, settranslations] = useState(null)
  const [ratingTitle, setratingTitle] = useState(null)
  const [rating1, setrating1] = useState(null)
  const [rating2, setrating2] = useState(null)


  useEffect(() => {
    const fetcher = async () => {
      const [res1, res2, res3] = await Promise.all ([
        (ratingTitle ||  ratingTitleRef2.current) && votingApi.translation("en", langForTransState, ratingTitle ?? ratingTitleRef2.current),
          (rating1 ||  rating1Ref2.current ) && votingApi.translation("en", langForTransState, rating1 ?? rating1Ref2.current),
          (rating2 ||  rating2Ref2.current) && votingApi.translation("en", langForTransState, rating2 ?? rating2Ref2.current)

      ])
      settranslations(() => {
        return {
          res1, res2, res3
        }
      })
      
    };
    !!isTranslated && !! ratingTitle && !!rating2 && !!rating1 && fetcher();
    
  }, [ isTranslated, ratingTitle, rating2, rating1, langForTransState])

  useEffect(() => {
    if (!!axisName) {
      if (true) {
        if (!!ratingTitleRef.current?.innerHTML && !ratingTitleRef2.current) {
          ratingTitleRef2.current = ratingTitleRef.current?.innerHTML
        }
        if (!!rating1Ref.current?.innerHTML && !rating1Ref2.current) {
          rating1Ref2.current = rating1Ref.current?.innerHTML
        }
        if (!!rating2Ref.current?.innerHTML && !rating2Ref2.current) {
          rating2Ref2.current = rating2Ref.current?.innerHTML
        }
        !!ratingTitleRef2.current && !ratingTitle && setratingTitle(() => ratingTitleRef2.current)
        !!rating1Ref2.current && !rating1 && setrating1(() => rating1Ref2.current)
        !!rating2Ref2.current && !rating2 && setrating2(() => rating2Ref2.current)
        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD11,
        //   payload: true
        // })
      }
    }
  }, [isTranslated, axisName, dispatch, ratingTitle, rating1, rating2])
  return (
    <Container>
      <RatingHeader>
        {
          !isTranslated && (
            <RatingItemHeader ref={ratingTitleRef} className="mb_5">{axisName}</RatingItemHeader>
          )
        }
        {
          !!isTranslated && (
            <RatingItemHeader ref={ratingTitleRef} className="mb_5" dangerouslySetInnerHTML={{__html: translations?.res1?.data}}></RatingItemHeader>
          )
        }
      </RatingHeader>
      <RatingItem>
        <RatingSliderScale>
          {
            !isTranslated && (
              <SliderScaleMin ref={rating1Ref}>{leftValue}</SliderScaleMin>
            )
          }
          {
            !!isTranslated && (
              <SliderScaleMin ref={rating1Ref} dangerouslySetInnerHTML={{__html: translations?.res2?.data}}></SliderScaleMin>
            )
          }
          {
            !isTranslated && (
              <SliderScaleMax ref={rating2Ref} >{rightValue}</SliderScaleMax>
            )
          }
          {
            !!isTranslated && (
              <SliderScaleMax ref={rating2Ref} dangerouslySetInnerHTML={{__html: translations?.res3?.data}} ></SliderScaleMax>
            )
          }
        </RatingSliderScale>
        <RatingSlider
          className={!isSliding ? "inactive" : ""}
          type="range"
          min="1"
          max="100"
          value={sliderVal}
          onChange={onChangeValue}
          onTouchStart={() => isMobile && mouseState("down")}
          onTouchEnd={() => isMobile && mouseState("up")}
          onMouseDown={() => !isMobile && mouseState("down")}
          onMouseUp={() => !isMobile && mouseState("up")}
        ></RatingSlider>
      </RatingItem>
    </Container>
  );
};

export default Slider;
